import clsx from 'clsx';
import React from 'react';

import styles from './CalculatingIndicator.module.scss';

interface CalculatingIndicatorProps {
  label?: string;
  className?: string;
}

export const CalculatingIndicator: React.FC<CalculatingIndicatorProps> = ({ label = 'Calculating…', className }) => (
  <span className={clsx(styles.calc, className)}>
    <span className={styles.spin} />
    {label}
  </span>
);
